import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { type OrchestratedOfferingListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import type { OfferDto, PaginatedOffersDto } from '@b-stock/offering-api-client'

import { findOffersQuery } from '@/buyer-portal/queries/findOffersQuery'
import listingDetailsQuery from '@/queries/listingDetailsQuery'

export const useUpdateOffersQueryData = () => {
  const queryClient = useQueryClient()

  return useCallback(
    ({
      accessToken,
      listingId,
      offeringId,
      offers,
    }: {
      accessToken: string
      listingId: string
      offeringId: string
      offers?: OfferDto[]
    }) => {
      if (offers) {
        queryClient.setQueryData(
          listingDetailsQuery.getKey(accessToken, [listingId]),
          (oldListingData: OrchestratedOfferingListingDetails | undefined) => {
            return {
              ...(oldListingData || {}),
              offers,
            }
          }
        )

        queryClient.setQueryData(
          findOffersQuery.getKey(accessToken, [{ offeringId }]),
          (findOffersData: PaginatedOffersDto | undefined) => {
            return {
              ...findOffersData,
              offers,
            }
          }
        )
      }
    },
    [queryClient]
  )
}
